import React from 'react';
// import logo from './logo.svg';
import './App.css';

// import Jumbotron from 'react-bootstrap/Jumbotron';
// import Container from 'react-bootstrap/Container';
// import Button from 'react-bootstrap/Button';
// import { Nav, Navbar } from 'react-bootstrap';
import Login from './componets/Login';
import config from './FirebaseConfig';
import firebaseService from './firebase/FirebaseService';

import firebase from "firebase/compat/app";
import 'firebase/compat/auth';

import {
  FirebaseAuthProvider,
  FirebaseAuthConsumer,
  // IfFirebaseAuthed,
  // IfFirebaseAuthedAnd
} from "@react-firebase/auth";
import Main from './componets/Main';

function App() {
  return (
    <FirebaseAuthProvider {...config} firebase={firebase}>
      <FirebaseAuthConsumer>
        {({ isSignedIn, user, providerId }) => {
          firebaseService.init();
          return (isSignedIn ? <Main /> : <Login />);
        }}
      </FirebaseAuthConsumer>
    </FirebaseAuthProvider>
  );
}

export default App;
